import { X } from "lucide-react";
import { useState } from "react";
import FilterCard from "../../shared/FilterCard";
import { useQuery } from "react-query";
import { getLoanOfficers } from "../../sdk/users/users";
import { getLoanProducts } from "../../sdk/products/products";
import Calendar from "react-calendar";

const LoanFilter = ({
  closeFilters,
  handleApplyFilter,
  status,
  setStatus,
  selectedLoanOfficer,
  setSelectedLoanOfficer,
  selectedLoanProduct,
  setSelectedLoanProduct,
  selectedLoanBalance,
  setSelectedLoanBalance,
  minLoanAmount,
  setMinLoanAmount,
  maxLoanAmount,
  setMaxLoanAmount,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) => {
  const [activeTab, setActiveTab] = useState("Status");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleStatusSelect = (label) => {
    setStatus(label.toLowerCase());
  };

  const handleOfficerSelect = (officerId) => {
    setSelectedLoanOfficer(officerId);
  };

  const handleProductSelect = (name) => {
    setSelectedLoanProduct(name);
  };

  const { data: loanOfficers } = useQuery({
    queryKey: ["loan officers"],
    queryFn: async () => {
      const response = await getLoanOfficers();
      return response.data.data.items;
    },
  });

  const { data: loanProducts } = useQuery({
    queryKey: ["loan-products"],
    queryFn: async () => {
      const response = await getLoanProducts();
      return response.data;
    },
  });

  const appliedFiltersCount = [
    status,
    selectedLoanOfficer,
    selectedLoanProduct,
  ].filter(Boolean).length;

  return (
    <div
      onClick={(e) => {
        closeFilters();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[800px] h-[580px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeFilters}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] right-[20px] flex items-center gap-[10px]">
          <button
            onClick={() => {
              setStatus("");
              setSelectedLoanOfficer("");
              setSelectedLoanProduct("");
              setMinLoanAmount("");
              setMaxLoanAmount("");
              setSelectedLoanBalance("");
            }}
            className="h-[35px] bg-[#FFFFFF] border border-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-[#000000]"
          >
            Clear Filters
          </button>
          <button
            onClick={handleApplyFilter}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            Apply Filters
          </button>
        </div>
        <div className="w-full">
          <p className="text-[#000000] text-[20px] font-medium">Filters</p>
          <p className="w-[90%] text-[#5C5C5C] text-[14px] font-normal">
            Refine your view by selecting specific criteria. Apply filters to
            quickly find the loans you need. You can reset or adjust filters
            anytime.
          </p>
          <div className="h-[435px] w-full flex">
            <div className="w-[30%] p-[10px] bg-[#F8F8F8] h-full overflow-y-auto">
              <div className="flex items-center justify-between">
                <p className="text-[#000000] text-[14px] font-medium">
                  Filters
                </p>
                <span className="bg-[#FFDEDE] text-[#000000] text-[12px] font-normal h-[30px] rounded-[30px] px-[10px] flex items-center justify-center">
                  {appliedFiltersCount} applied
                </span>
              </div>
              <div className="flex flex-col my-[20px] gap-[20px]">
                <FilterCard
                  label="Status"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Minimum Loan Amount"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Maximum Loan Amount"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Loan Type"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Balance"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="Loan Officer"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="From Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="To Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
              </div>
            </div>

            <div className="w-[70%] p-[10px] bg-[#FBF5F5] h-full">
              <p className="text-[#000000] text-[14px] font-medium">
                {activeTab}
              </p>
              <p className="text-[#222222] text-[14px] font-normal">
                Select your {activeTab?.toLowerCase()} filter
              </p>
              {activeTab === "Status" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] overflow-y-auto rounded-[5px] h-[360px]">
                  {[
                    "Active",
                    "Closed",
                    "Defaulted",
                    "Inarrears",
                    "Awaiting Disbursement",
                    "Written_off",
                  ].map((label) => (
                    <div
                      key={label}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {label}
                      </p>
                      <input
                        type="radio"
                        name="status"
                        checked={status === label.toLowerCase()}
                        onChange={() => handleStatusSelect(label)}
                      />
                    </div>
                  ))}
                </div>
              )}
              {activeTab === "Minimum Loan Amount" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {[
                    "10000",
                    "25000",
                    "50000",
                    "100000",
                    "250000",
                    "250001",
                  ].map((amount) => (
                    <div
                      key={amount}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {amount === "250001"
                          ? "Above KES 250,000"
                          : `KES ${parseInt(amount).toLocaleString()}`}
                      </p>
                      <input
                        type="radio"
                        name="minLoanAmount"
                        value={amount}
                        checked={minLoanAmount === amount}
                        onChange={(e) => setMinLoanAmount(e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "Maximum Loan Amount" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {[
                    "10000",
                    "25000",
                    "50000",
                    "100000",
                    "250000",
                    "250001",
                  ].map((amount) => (
                    <div
                      key={amount}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {amount === "250001"
                          ? "Above KES 250,000"
                          : `KES ${parseInt(amount).toLocaleString()}`}
                      </p>
                      <input
                        type="radio"
                        name="maxLoanAmount"
                        value={amount}
                        checked={maxLoanAmount === amount}
                        onChange={(e) => setMaxLoanAmount(e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "Loan Type" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {loanProducts?.length > 0 ? (
                    loanProducts.map((product) => (
                      <div
                        key={product?.id || product?.name}
                        className="flex mb-[20px] items-center justify-between"
                      >
                        <p className="text-[#000000] text-[14px] font-normal">
                          {product?.name}
                        </p>
                        <input
                          type="radio"
                          name="product"
                          value={product?.name}
                          checked={selectedLoanProduct === product?.name}
                          onChange={() => handleProductSelect(product?.name)}
                        />
                      </div>
                    ))
                  ) : (
                    <p>No data on loan products</p>
                  )}
                </div>
              )}
              {activeTab === "Balance" && (
                <div className="w-full border border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {[
                    "0-10000",
                    "10001-25000",
                    "25001-50000",
                    "50001-100000",
                    "100001-250000",
                    "250001+",
                  ].map((range) => (
                    <div
                      key={range}
                      className="flex mb-[20px] items-center justify-between"
                    >
                      <p className="text-[#000000] text-[14px] font-normal">
                        {range === "250001+"
                          ? "Above KES 250,000"
                          : `KES ${range.split("-")[0]} - ${
                              range.split("-")[1]
                            }`}
                      </p>
                      <input
                        type="radio"
                        name="loanBalance"
                        value={range}
                        checked={selectedLoanBalance === range}
                        onChange={(e) => setSelectedLoanBalance(e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "Loan Officer" && (
                <div className="w-full border overflow-y-auto border-[#D4D8E2] mt-[10px] p-[10px] rounded-[5px] h-[360px]">
                  {loanOfficers?.length > 0 ? (
                    loanOfficers?.map((officer) => (
                      <div
                        key={officer?.id}
                        className="flex mb-[20px] items-center justify-between"
                      >
                        <p className="text-[#000000] text-[14px] font-normal">
                          {officer?.firstname} {officer?.lastname}
                        </p>
                        <input
                          type="radio"
                          name="loanOfficer"
                          checked={selectedLoanOfficer === officer?.id}
                          onChange={() => handleOfficerSelect(officer?.id)}
                        />
                      </div>
                    ))
                  ) : (
                    <p>No loan officer data</p>
                  )}
                </div>
              )}
              {activeTab === "From Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={(val) => setFromDate(val)}
                    value={fromDate ? new Date(fromDate) : null}
                    maxDate={toDate ? new Date(toDate) : new Date()}
                  />
                </div>
              )}
              {activeTab === "To Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={(val) => setToDate(val)}
                    value={toDate ? new Date(toDate) : null}
                    minDate={fromDate ? new Date(fromDate) : null}
                    maxDate={new Date()}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanFilter;
